module.exports = __webpack_public_path__ + "img/unknown-icon.7bda5c1a.svg";